import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { Materials } from "@/components/sections/Materials";
import { MaterialRender } from "@/components/sections/MaterialRender";
import { MATERIAL_PROPERTIES } from "@/content/pagesContent";

export default function Materiali() {
  return (
    <SiteLayout>
      <PageHero
        testId="materiali-page"
        micro="MATERIALI"
        title="PLA, il nostro materiale principale."
        description="Rigido, stabile e con finitura pulita. Ideale per prototipi, componenti visivi e piccole serie. Cinque colori standard, con altri materiali e colori su richiesta."
      />

      <Materials />
      <MaterialRender />

      <Section id="material-properties-section" tone="light">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionHeading
                microLabel={MATERIAL_PROPERTIES.microLabel}
                title={MATERIAL_PROPERTIES.title}
                description={MATERIAL_PROPERTIES.description}
              />
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <ul className="divide-y divide-strato-gray-100 border-y border-strato-gray-100">
              {MATERIAL_PROPERTIES.rows.map((row, i) => (
                <Reveal key={row.label} delay={i * 0.03}>
                  <li className="flex items-start justify-between gap-6 py-4">
                    <MicroLabel className="text-muted-foreground">{row.label}</MicroLabel>
                    <span className="max-w-[40ch] text-right text-sm font-medium text-strato-graphite">
                      {row.value}
                    </span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </Section>

      <CtaBand secondaryTo="/come-funziona" secondaryLabel="Come funziona" />
    </SiteLayout>
  );
}
